import React from "react";
import { cn } from "../../../../util/lib";

export const SectionTitle = ({ title, className = "" }) => (
  <div className={cn("mt-6 mb-3 border-b border-slate-200 pb-2", className)}>
    <h3 className="text-lg font-bold text-slate-800">{title}</h3>
  </div>
);

export const FormInput = ({
  label,
  value,
  onChange,
  onBlur,
  disabled = false,
  type = "text",
  placeholder = "",
  className = "",
  inputClassName = "",
  suffix = null,
}) => (
  <div className={cn("flex flex-col gap-1", className)}>
    <div className="flex items-center justify-between">
      {label && <label className="text-xs font-semibold text-slate-600">{label}</label>}
      {suffix}
    </div>
    <input
      type={type}
      value={value ?? ""}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      placeholder={placeholder}
      className={cn(
        "w-full h-[38px] px-2.5 text-sm font-semibold border border-slate-300 rounded-md bg-white text-slate-800 placeholder:text-slate-400 placeholder:text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 disabled:bg-slate-100 disabled:text-slate-500 disabled:border-slate-200 disabled:cursor-not-allowed transition-colors",
        inputClassName
      )}
    />
  </div>
);

export const FormSelect = ({
  label,
  value,
  onChange,
  disabled = false,
  children,
  className = "",
  selectClassName = "",
}) => (
  <div className={cn("flex flex-col gap-1", className)}>
    {label && <label className="text-xs font-semibold text-slate-600">{label}</label>}
    <select
      value={value ?? ""}
      onChange={onChange}
      disabled={disabled}
      className={cn(
        "w-full h-[38px] px-2.5 text-sm font-semibold border border-slate-300 rounded-md bg-white text-slate-800 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 disabled:bg-slate-100 disabled:text-slate-500 disabled:border-slate-200 disabled:cursor-not-allowed transition-colors",
        selectClassName
      )}
    >
      {children}
    </select>
  </div>
);

